import { useEffect, useRef, useState } from "react";
import InfoSvg from "../../assets/svg/InfoSvg";
import "./Notification.scss";
import CrossSvg from "../../assets/svg/CrossSvg";
import gsap from "gsap";

function Notification({ message, type, removeNotification }) {
    const [show, setShow] = useState(true);
    const pageRef = useRef(null);

    useEffect(() => {
        pageRef.current && gsap.fromTo(pageRef.current,
            {opacity: 0, y: -100, scaleY: .95, scaleX: .85},
            {opacity: 1, y: 0, scale: 1, duration: .5, ease: "power2.out", onComplete: () => setTimeout(() => setShow(false), 5000)},
        );
    }, []);

    useEffect(() => {
        if (!show && pageRef.current) {
            gsap.to(pageRef.current, {opacity: 0, y: -100, scaleY: .95, scaleX: .85, duration: .5, ease: "power2.out", onComplete: removeNotification});
        };
    }, [show, removeNotification]);

    return (
        <div className="notification-wrapper" ref={pageRef}>
            <div className="notification-content">
                <div className="notification-left">
                    <div className="notification-icon">
                        <InfoSvg />
                    </div>

                    <div className="notification-text">
                        <span>{message}</span>
                    </div>
                </div>

                <div className="notification-right" onClick={() => setShow(false)}>
                    <CrossSvg />
                </div>
            </div>
        </div>
    );
};

export default Notification;